import { Directive, OnInit, OnChanges, SimpleChanges, Input, Injector, Optional, HostListener, ElementRef } from '@angular/core';
import { BindingData, BindingList, FrameContext, Change, ChangeType } from '@farris/devkit';
import { UploadFile, FFilePreviewComponent, UploadAndPreviewComponent } from '@farris/extend-file-upload';

/**
 * æ è¡¨æ ¼ç»å®æä»¤
 */
@Directive({
  selector: '[farrisFilePreviewBinding]'
})
class FarrisFilePreviewBindingDirective implements OnInit, OnChanges {
  private __DATA__: any;
  /**
   * æªå¯ç¨æåºæ¶é»è®¤æä¸ä¼ æ¶é´å­æ®µæåº
   */
  private readonly DEFAULT_SORT_FIELD = 'createTime';
  /**
   * å¯ç¨æåºæ¶ä½¿ç¨fileSortOrderåæåºå­æ®µï¼ä¸é¶ä»£ç çææ½æåºç»ä¸
   */
  private readonly SORT_FIELD_ON_SORTING = 'fileSortOrder';
  @Input('extendFileInfo')
  public extendFileInfo: { key: string, path: any }[];
  /**
   * æåºæ¹å¼
   */
  @Input('farrisOrderType')
  public farrisOrderType: string;
  /**
   * æä»¶idå­æ®µè·¯å¾
   */
  @Input('farrisFileIdKey')
  public fileIdKey: string;
  /**
   * æåºå­æ®µï¼ææ½æåºç¸å³
   */
  @Input('farrisFileSortOrderKey')
  public fileSortOrderKey: string;
  /**
   * æä»¶nameå­æ®µè·¯å¾
   */
  @Input('farrisFileNameKey')
  public fileNameKey: string;

  /**
   * ç»å®æ°æ®
   */
  private get bindingData(): BindingData {
    return this.frameContext.bindingData;
  }

  /**
   * ç»å®æ°æ®åè¡¨
   */
  private get bindingList(): BindingList {
    return this.bindingData.getList();
  }
  /**
   * æåºå­æ®µ
   * @description
   * ç»ä»¶æåºå­æ®µåªæä¸ä¸ªï¼ä¸æ¯æå¤ä¸ªã
   * å¦æå¯ç¨äºææ½æåºï¼åä¸ºfileSortOrderï¼å¦åä½¿ç¨é»è®¤çcreateTime
   */
  private get orderField() {
    return this.uploadAndPreviewComponent && this.uploadAndPreviewComponent.enableOrder && this.uploadAndPreviewComponent.orderField || this.fileSortOrderKey && this.SORT_FIELD_ON_SORTING || this.DEFAULT_SORT_FIELD;
  }
  /**
   * é»è®¤éåº
   */
  private get orderType() {
    return this.farrisOrderType ? this.farrisOrderType : this.orderField === this.DEFAULT_SORT_FIELD ? 'desc' : 'asc';
  }
  /**
   * æé å½æ°
   * @param previewComponent - éä»¶ç»ä»¶
   * @param frameContext - æ§å¶å¨ä¸ä¸æ
   * @param uploadAndPreviewComponent - éä»¶ä¸ä¼ é¢è§ç»ä»¶
   * @param injector - injector
   * @TODO: è¯¥æä»¤è¢«ç¨äºä¸åçç»ä»¶ä¸­ï¼å æ­¤uploadAndPreviewComponentå¯è½ä¸ºnull
   */
  constructor(
    @Optional() private previewComponent: FFilePreviewComponent,
    private frameContext: FrameContext,
    @Optional() private uploadAndPreviewComponent: UploadAndPreviewComponent,
    @Optional() private injector: Injector,
    @Optional() private elementRef: ElementRef
  ) {
  }

  /**
   * æä»¤åå§å
   */
  ngOnInit() {
    this.bindData();
    if (this.uploadAndPreviewComponent) {
      if (this.uploadAndPreviewComponent.enableOrder) {
        this.uploadAndPreviewComponent.orderField = this.SORT_FIELD_ON_SORTING;
      }
      // ç¦ç¨ç»ä»¶åç½®æåºï¼æ§å¶å¨è´è´£æåºå¹¶å°æåºåçæ°æ®ç»å®å°éä»¶ä¸ä¼ é¢è§ç»ä»¶
      this.uploadAndPreviewComponent.enableSorting = false;
      this.uploadAndPreviewComponent.fSelectedEvent.subscribe((event: any) => {
        const primaryKey = this.bindingList.primaryKey;
        const id = event && event.originalData && event.originalData[primaryKey];
        if (id && id !== this.bindingList.currentId) {
          this.bindingList.setCurrentId(id, true);
        }
      });
      this.registeValueChangeEvent();
      // æ·»å ç»ä»¶å®ä¾
      const id = this.elementRef && this.elementRef.nativeElement && this.elementRef.nativeElement.id;
      if (this.frameContext && id && this.uploadAndPreviewComponent && !this.frameContext.componentRefManager.has(id)) {
        this.frameContext.componentRefManager.add(id, this.uploadAndPreviewComponent);
      }
    }
    this.bindingData.changes.subscribe((change: Change) => {
      // å æåºéè¦ï¼å¼ååæ¶ä¹åºè¿è¡æ°æ®ç»å®
      if (change.type === ChangeType.Load || change.type === ChangeType.Append || change.type === ChangeType.Remove || change.type === ChangeType.ValueChanged || change.type === ChangeType.SelectionChanged) {
        this.bindData(change);
        this.updateCurrentRow(change);
        this.updateChecks(change);
      }
    });
    this.setChecks([]);
  }

  /**
   * æä»¤è¾å¥åæ´
   * @param changes -åæ´
   */
  ngOnChanges(changes: SimpleChanges) {
  }
  private shouldComponentUpdate(data: any) {
    return !(JSON.stringify(this.__DATA__) === JSON.stringify(data));
    // return !(this.__DATA__ && isEqual(this.__DATA__, data));
  }
  private registeValueChangeEvent() {
    // å¼ååäºä»¶
    if (this.uploadAndPreviewComponent && this.uploadAndPreviewComponent.editorValueChanged) {
      this.uploadAndPreviewComponent.editorValueChanged.subscribe((event: any) => {
        const { id = null } = event || {};
        if (!id) {
          return;
        }
        const bindingList: BindingList = this.frameContext.bindingData.getList() as BindingList;
        if (!bindingList) {
          return;
        }
        const bindingPaths = this.frameContext && this.frameContext.viewModel && this.frameContext.viewModel.bindingPath && this.frameContext.viewModel.bindingPath.split('/').filter((p) => p) || [];
        Object.keys(event).forEach((key: string) => {
          if (key === 'id' || key === 'column') {
            return;
          }
          // å¼å®¹å¤æå­æ®µ
          const keys = key.split('.').filter((item) => item);
          // ä»æ¯æå¯çº§ï¼å¶ä»åºæ¯éè¦å¤æ­ç¼è¾å¨ç±»åï¼å¹¶åæ°æ®è½¬æ¢
          const value = event[key];
          if (id === bindingList.currentId) {
            this.frameContext.bindingData.setValue(bindingPaths.concat(keys), value, true, true);
          } else {
            const bindingObject = bindingList && bindingList.findById(id);
            if (!bindingObject) {
              return;
            }
            if (keys.length >= 2) {
              let targetBindingObject = null;
              const fpaths = keys.slice(0, keys.length - 1);
              const targetPropertyName = keys[keys.length - 1];
              fpaths.forEach((prop, index: number) => {
                if (index === 0) {
                  targetBindingObject = bindingObject[prop];
                } else {
                  targetBindingObject = targetBindingObject && targetBindingObject[prop] || null;
                }
              });
              if (!targetBindingObject) {
                return;
              }
              // todo:éè¦æ·»å å¼ååäºä»¶
              targetBindingObject.setValue(targetPropertyName, value, true, true);
            } else {
              bindingObject.setValue(key, value, true, true);
            }
          }
        });
      });
    }
  }
  /**
   * ç»å®æ°æ®
   * @param change -åæ´
   */
  private bindData(change?: Change) {
    const bindingPath = this.frameContext.viewModel.bindingPath.split('/').filter(p => p).join('/');
    const eventPath = change && change.path && change.path.filter(p => p).join('/');
    // è¡åæ¢ãå é¤ãå è½½ãæ°å¢æ°æ®ãé¡µç åæ¢ åºæ¯
    if (change && [ChangeType.SelectionChanged, ChangeType.Remove, ChangeType.Load, ChangeType.Append].includes(change.type)) {
      // éä¸çº§å®ä½ä¸éæ°ç»å®æ°æ®
      if (!bindingPath.startsWith(eventPath)) {
        return;
      }
      // å½åéä»¶ç»ä»¶åæ¢å½åè¡ä¸éè¦éæ°æ¸²æ
      if (change.type === ChangeType.SelectionChanged && bindingPath === eventPath) {
        return;
      }
    }
    // éå½åå®ä½åçäºå¼åå
    if (change && change.type === ChangeType.ValueChanged && !eventPath.startsWith(bindingPath)) {
      return;
    }
    const fileInfos = this.getFileInfos();
    if (!this.shouldComponentUpdate(fileInfos)) {
      return;
    }
    if (this.componentRef) {
      this.__DATA__ = fileInfos;
      this.componentRef.fileInfos = fileInfos;
      if (this.uploadAndPreviewComponent && fileInfos && fileInfos.length > 0) {
        const extendInfos = fileInfos.map((item: any) => item.originalData);
        this.uploadAndPreviewComponent.extendInfos = extendInfos;
      }
      this.changeCurrentRow(fileInfos, change);
    }
  }
  private updateChecks(change?: Change) {
    if (!this.uploadAndPreviewComponent) {
      return;
    }
    const bindingPath = this.frameContext.viewModel.bindingPath.split('/').filter(p => p).join('/');
    const eventPath = change && change.path && change.path.filter(p => p).join('/');
    // å é¤èªèº«è¡¨æ¶æ´æ°å¾éè®°å½
    if (change && change.type === ChangeType.Remove && eventPath === bindingPath) {
      const values = change.value || [];
      const ids: any[] = this.frameContext.uiState['ids'] || [];
      if (values.length > 0 && ids.length > 0) {
        values.forEach((id: string) => {
          const index = ids.indexOf(id);
          if (index !== -1) {
            ids.splice(index, 1);
          }
        });
      }
    } else if ((change.type === ChangeType.Remove || change.type === ChangeType.SelectionChanged) && bindingPath.startsWith(eventPath) && bindingPath !== eventPath) {
      //ä¸çº§ï¼ä¸ä¸çº§ï¼è¡¨å é¤ãä¸çº§ï¼ä¸ä¸çº§ï¼è¡¨åæ¢å½åè¡æ¶æ´æ°å¾éè®°å½
      this.setChecks([]);
      // æ¸ç©ºç»ä»¶å¾é
      this.clearComponentChecks();
    } else if (change && change.type === ChangeType.Load && (bindingPath === eventPath || bindingPath.startsWith(eventPath) && bindingPath !== eventPath)) {
      // å½åéä»¶ç»ä»¶æ°æ®éæ°å è½½ or ä¸çº§æä¸ä¸çº§éæ°å è½½
      this.setChecks([]);
      // æ¸ç©ºç»ä»¶å¾é
      this.clearComponentChecks();
    }
  }
  /**
   * ä¸»å¨æ´æ°å½åè¡
   * @param data - æ°æ®
   * @param change - åæ´
   */
  private changeCurrentRow(data: any, change?: Change) {
    if (!this.uploadAndPreviewComponent) {
      return;
    }
    const changePath = change && change.path.join('/');
    const paths = this.frameContext.viewModel.bindingPath.split('/').filter(p => p);
    const path = paths.join('/');
    const isParentSelectChange = path.startsWith(changePath) && change.type === ChangeType.SelectionChanged && path !== changePath;
    const isSelfRowDelete = change && change.type === ChangeType.Remove && path === changePath;
    if (data && data.length > 0 && change && (change.type === ChangeType.Load || isParentSelectChange || isSelfRowDelete)) {
      const primaryKey = this.bindingList.primaryKey;
      const id = data[0]['originalData'] && data[0]['originalData'][primaryKey];
      if (this.bindingList.currentId !== id) {
        setTimeout(() => {
          this.bindingList.setCurrentId(id, true, true);
        }, 100);
      }
    }
  }
  /**
   * ä¸ºæ§ä»¶è®¾ç½®å½åè¡
   * @param change - æ§å¶å¨åæ´
   * @returns
   */
  private updateCurrentRow(change?: Change) {
    if (!this.bindingList || !this.bindingList.currentId || !this.uploadAndPreviewComponent) {
      return;
    }
    if (change && change.type !== ChangeType.SelectionChanged && change.type !== ChangeType.Load && change.type !== ChangeType.Remove) {
      return;
    }
    const currentId = this.uploadAndPreviewComponent.previewCurrent;
    // ç»ä»¶idåæ°æ®idè¿è¡è½¬æ¢
    const id = this.getValueByPath(this.bindingList.currentItem, this.fileIdKey);
    if (id === currentId) {
      return;
    }
    this.selectComponentRow(id);
  }
  /**
   * è·åéä»¶ä¿¡æ¯åè¡¨
   */
  private getFileInfos(): UploadFile[] {
    const listData = this.bindingList.toJSON();
    const fileInfos: UploadFile[] = [];
    listData.forEach((itemData: any) => {
      const fileInfo = this.convertToFileInfo(itemData);
      fileInfos.push(fileInfo);
    });
    // æåº
    if (this.orderField) {
      this.sort(fileInfos, this.orderField, this.orderType);
    }
    return fileInfos;
  }
  /**
   * è¡æ°æ®è½¬æ¢ä¸ºæä»¶ä¿¡æ¯
   * @param itemData - è¡æ°æ®
   * @returns
   */
  private convertToFileInfo(itemData: any) {
    // const idKey = this.bindingList.primaryKey;
    // const id = this.getValueByPath(itemData, idKey);
    const fileId = this.getValueByPath(itemData, this.fileIdKey);
    const fileName = this.getValueByPath(itemData, this.fileNameKey);
    const fileSize = this.getValueByPath(itemData, this.fileSizeKey);
    const fileCreateTime = this.getValueByPath(itemData, this.fileCreateTimeKey);

    const fileInfo: any = {
      id: fileId,
      name: fileName,
      size: fileSize,
      createTime: fileCreateTime,
      originalData: itemData,
      extend: {
        metadataId: fileId
      }
    };
    if (this.extendFileInfo && Array.isArray(this.extendFileInfo) && this.extendFileInfo.length > 0) {
      this.extendFileInfo.forEach((item) => {
        fileInfo[item.key] = this.getValueByPath(itemData, item.path);
      });
    }
    if (this.fileSortOrderKey) {
      const fileSortOrder = this.getValueByPath(itemData, this.fileSortOrderKey);
      fileInfo[this.SORT_FIELD_ON_SORTING] = fileSortOrder;
    }
    return fileInfo;
  }
  /**
   * è®¾ç½®æ§ä»¶çå½åè¡
   * @param id ä¸»é®
   */
  private selectComponentRow(id) {
    if (this.uploadAndPreviewComponent) {
      this.uploadAndPreviewComponent.previewCurrent = id;
    }
  }
  /**
   * æ ¹æ®å­æ®µè·¯å¾è·åå¼
   * @param data - æ°æ®æº
   * @param path - å­æ®µè·¯å¾
   */
  private getValueByPath(data: any, path: string): any {
    const keys = path.split('.');
    let currentValue = data;
    keys.forEach((key: string) => {
      currentValue = currentValue && currentValue[key];
    });
    return currentValue;
  }
  private getUdtPaths(): string[] {
    const paths = this.fileIdKey.split('.');
    paths.pop();
    return paths;
  }
  private get fileSizeKey() {
    const basePaths = this.getUdtPaths();
    return basePaths.concat(['fileSize']).join('.');
  }
  private get fileCreateTimeKey() {
    const basePaths = this.getUdtPaths();
    return basePaths.concat(['fileCreateTime']).join('.');
  }
  private get componentRef() {
    return this.previewComponent || this.uploadAndPreviewComponent || null;
  }
  private setChecks(ids: any) {
    this.frameContext.uiState.setPropertyValue('ids', ids);
  }
  /**
   * æ¸ç©ºç»ä»¶å¾é
   */
  private clearComponentChecks() {
    if (this.uploadAndPreviewComponent) {
      this.uploadAndPreviewComponent.previewUpdateRefresh();
    }
  }
  public sort(data: any[], fields: string | Array<string>, directions: string | Array<string>) {
    if (!fields || fields.length < 1 || !directions || directions.length < 1) {
      throw new Error('sortBy:argument error');
    }
    // é»è®¤ååº
    const arrFields: Array<string> = typeof fields === 'string' ? fields.split(',') : fields || [];
    const arrDirections: Array<string> = typeof directions === 'string' ? directions.split(',') : directions || [];
    // æåºå­æ®µåæåºæ¹å¼åºä¸è´
    if (arrFields.length !== arrDirections.length || arrFields.length < 1) {
      throw new Error('sortBy:fields and directions not match');
    }
    // nage,age,total
    const comparator = (props: Array<string>, orders: Array<string>) => (item1: any, item2: any) => {
      return props.reduce((result, prop) => {
        if (result === 0) {
          const order = ['asc'].includes(orders[props.indexOf(prop)]) ? 1 : -1;
          const item1Value = this.getValue(item1, prop);
          const item2Value = this.getValue(item2, prop);
          if (item1Value === null || item1Value === undefined) {
            return 1;
          }
          if (item2Value === null || item2Value === undefined) {
            return -1;
          }

          if (typeof item1Value !== typeof item2Value) {
            const localeCompareResult = String(item1Value).localeCompare(String(item2Value));
            result = localeCompareResult * order;
          } else if (typeof item1Value === 'string' && typeof item2Value === 'string') {
            const localeCompareResult = item1Value.localeCompare(item2Value);
            result = localeCompareResult * order;
          } else {
            if (item1Value > item2Value) {
              result = order * 1;
            }
            if (item1Value < item2Value) {
              result = order * -1;
            }
          }
        }
        return result;
      }, 0);
    };
    data.sort(comparator(arrFields, arrDirections));
  }
  private getValue(target: any, propName: string) {
    if (target instanceof BindingList) {
      target = target.currentItem;
    } else if (target instanceof BindingData) {
      target = target.list.currentItem;
    }
    let result = null;
    if (propName.indexOf('.') === -1) {
      result = target[propName];
    } else {
      const props = propName.split('.');
      for (const prop of props) {
        target = result = this.getValue(target, prop);
      }
    }
    return result;
  }
  /**
   * å¾éååäºä»¶
   * @param event
   */
  @HostListener('fPreviewMultiSelectedEvent', ['$event'])
  private checkedChanged(event: any[]) {
    const primaryKey = this.bindingList.primaryKey;
    const ids = event && event.map((item) => item && item.originalData && item.originalData[primaryKey] || '').filter(p => p) || [];
    this.setChecks(ids);
  }
  /**
   * è¡åæ¢äºä»¶
   * @param event
   */
  @HostListener('fSelectedEvent', ['$event'])
  private selectChanged(event: any) {

  }
}

export { FarrisFilePreviewBindingDirective };
